//@import dependencies
import React, { useEffect, useState, CSSProperties } from 'react'
import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
//@end

//@import components
import Rating from 'react-rating';
import { AiFillStar } from 'react-icons/ai';
//@end

// @import hooks
// @end

// @INFO Import types
// @end

// @INFO Import services
// @end

// @INFO Import Styles
import './../questionselectrangeModule.scss'

// @ADD Component types
interface IQuestionselectrangeModuleLayoutProps {
  questionData: any
  defaultAnswer: string | null
  className?: string
  style?: CSSProperties
  hideButtons?: boolean
  disabled?: boolean
  showCorrect?: boolean
  showMyResponse?: boolean
  validateMyResponse?: boolean
  showFeedback?: boolean
  onNextQuestion: (data: any) => void
  handleSendOnChange: (text: number) => any
  getDefaultAnswer: (data: any) => any
}

const QuestionselectrangeModuleLayout: React.FC<IQuestionselectrangeModuleLayoutProps> = (props) => {

  // const [textStatus, setTextStatus] = useState<string>(props.defaultAnswer ? props.defaultAnswer : '')
  const [quelification, updateQualification] = useState<number>(0)
  const { t } = useTranslation()
  const form = useForm()

  useEffect(() => {
    props.handleSendOnChange(quelification)
  }, [quelification])

  useEffect(() => {
    const result = props.getDefaultAnswer(props.questionData)
    updateQualification(Number(result))
  }, [props.questionData._id])

  return(
    <div className='question_select_range-component'>
      <div className='answer-container'>
        <div className='answer'>
          {/* <form onSubmit={form.handleSubmit((data) => props.onNextQuestion(data))}>
            {getComponentFromType(props?.questionData?.config?.type_input)}
          </form> */}
          <div className="container-rating-question">
            <span
              style={{ fontSize: '0.85rem' }}
            >
              {`(1 el menor grado de valoración y ${props.questionData?.config?.range} el de mayor percepción)`}
            </span>
            <Rating
                emptySymbol={<AiFillStar className='icon-star-rating' style={{ color: '#C1C8C8'}} />}
                fullSymbol={<AiFillStar className='icon-star-rating' style={{ color: '#FFD100'}} />}
                start={0}
                stop={props.questionData?.config?.range}
                onChange={(val) => updateQualification(val)}
                initialRating={quelification}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default QuestionselectrangeModuleLayout
